<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';

const props = defineProps({
  conversationId: { type: [Number, String], required: true },
  messageId: { type: [Number, String], required: true },
});

const { t } = useI18n();
const store = useStore();
const dialogRef = ref(null);
const isLoading = ref(false);
const content = ref('');

const open = originalContent => {
  content.value = originalContent;
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

const handleConfirm = async () => {
  if (!content.value.trim()) return;

  isLoading.value = true;
  try {
    await store.dispatch('editMessage', {
      conversationId: props.conversationId,
      messageId: props.messageId,
      content: content.value,
    });
    close();
  } catch (error) {
    useAlert(
      parseAPIErrorResponse(error) ||
        t('CONVERSATION.CONTEXT_MENU.EDIT_MESSAGE.ERROR')
    );
  } finally {
    isLoading.value = false;
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('CONVERSATION.CONTEXT_MENU.EDIT_MESSAGE.TITLE')"
    :confirm-button-label="t('CONVERSATION.CONTEXT_MENU.EDIT_MESSAGE.SUBMIT')"
    :is-loading="isLoading"
    :disable-confirm-button="!content.trim()"
    @confirm="handleConfirm"
  >
    <TextArea v-model="content" class="w-full" auto-height />
  </Dialog>
</template>
